import React from 'react';

interface auth {
    isAuth: boolean;
    data: any;
}
const AuthContext = React.createContext<auth>({ isAuth: false, data:null });

export default AuthContext;
